import { createContext } from "react"
export const TranslateContext = createContext<boolean>(false)
export const SetTranslateContext = createContext(null)